var SearchController;
(function (SearchController) {
    myonce("search", () => {
        const $wrapper = document.querySelector('#search');
        if ($wrapper) {
            const $filterBar = $wrapper.querySelector('.filter-bar');
            const $form = $wrapper.querySelector('.filter-bar form');
            const $query = $wrapper.querySelector('.search-header .input-group input');
            const $clear = $wrapper.querySelector('.search-header .head .input-group [data-clear]');
            const $searchBtn = $wrapper.querySelector('.icn.icn-search');
            const $btnResetAll = $wrapper.querySelector('a.reset-all');
            const $resultCount = $wrapper.querySelector('.result-count');
            const $resultsClusterDummy = $wrapper.querySelector('.result-cluster.dummy');
            const $results = $wrapper.querySelector('.results');
            const index = $wrapper.querySelector('.search-index').value;
            let cacheCategories = {};
            let cacheFacets;
            let payload = {
                query: '*',
                date: Date.now(),
                index,
                order: 'DESC',
                page: 0,
                paging: 0,
                filters: [],
            };
            const selectsConfiguration = {
                hideSelected: false,
                hideDisabled: true,
                multiShowCount: false,
                multiSelectAll: false
            };
            let currentPage = 0;
            let clusters = {};
            let valuesInputIncludes = [];
            let valuesInputCategory = [];
            function search(data) {
                $wrapper.setAttribute('data-spinner', 'mask');
                return Fetch('/api/search', {
                    method: 'POST',
                    token: {
                        enable: true,
                    },
                    data
                });
            }
            function executeSearch() {
                payload = updatePayload(payload);
                setResetAllFilters(payload);
                search(payload).then(results => {
                    cacheFacets = results.facets;
                    print(results);
                    AdvertisingCatalog();
                }).catch((e) => {
                    console.log(e);
                    $wrapper.removeAttribute('data-spinner');
                });
            }
            function getOsbImage() {
                const $targets = document.querySelectorAll('img');
                $targets.forEach(($target) => {
                    const imageId = $target.getAttribute('src');
                    if (imageId.indexOf('/') === -1) {
                        Fetch('/api/getImage/' + imageId, { method: 'GET', token: { enable: true } })
                            .then(body => {
                            $target.setAttribute('src', body["data"]);
                        });
                    }
                });
            }
            function bindFilterModalSearch($containerModal, $modal, idModal) {
                const $cards = $containerModal.querySelectorAll('.card');
                switch (idModal) {
                    case 'modalAllergens':
                        filterAllergen($cards, $containerModal, $modal);
                        break;
                    case 'modalProductLine':
                        filterProductLine($cards, $containerModal, $modal);
                        break;
                    case 'modalCategory':
                        filterCategory($cards, $containerModal, $modal);
                        break;
                }
            }
            function productCategory(id) {
                return Fetch(`/api/product_category/${id}`, {
                    method: 'GET',
                    token: {
                        enable: true,
                    }
                });
            }
            function findSubcategory($id) {
                getCategory($id).then(results => {
                    if (results.length === 0) {
                        valuesInputCategory.push($id);
                    }
                    printCheckAllCategories($id);
                    results.forEach(result => {
                        printCategory(result);
                    });
                    removeFilterFacets();
                });
            }
            function setResetAllFilters(payload) {
                const noFilters = (currentValue) => currentValue.value == '';
                const hiddenFilters = $filterBar.querySelectorAll('.hidden-filter');
                if (hiddenFilters.length) {
                    let newList = payload.filters;
                    hiddenFilters.forEach(hiddenFilter => {
                        const hiddenFilterName = hiddenFilter.getAttribute('name');
                        newList = newList.filter(filter => filter.id !== hiddenFilterName);
                    });
                    if (newList.every(noFilters)) {
                        $btnResetAll.classList.add('hide');
                    }
                    else {
                        $btnResetAll.classList.remove('hide');
                    }
                }
                else {
                    if (payload.filters.every(noFilters)) {
                        $btnResetAll.classList.add('hide');
                    }
                    else {
                        $btnResetAll.classList.remove('hide');
                    }
                }
            }
            function updatePayload(payload) {
                return {
                    ...payload,
                    query: ignoreCase($query.value) || '*',
                    filters: gatherFilters(),
                    facets: gatherFacets(),
                    page: 0
                };
            }
            function ignoreCase(str) {
                if (str) {
                    let originalString = str.split(' ');
                    let ignoreCaseString = [];
                    originalString.forEach((word) => {
                        let lowCase, upCase;
                        lowCase = word.charAt(0).toLowerCase() + word.slice(1);
                        upCase = word.charAt(0).toUpperCase() + word.slice(1);
                        ignoreCaseString.push(lowCase);
                        ignoreCaseString.push(upCase);
                    });
                    str = ignoreCaseString.join(' ');
                }
                return str;
            }
            function gatherFilters() {
                let filters = [];
                const data = new FormData(document.querySelector('form'));
                const wornKeys = {};
                for (let key of data.keys()) {
                    let operator = '';
                    let value;
                    if (!(key in wornKeys)) {
                        wornKeys[key] = true;
                        value = data.getAll(key);
                        value = value.reduce((acc, curr) => {
                            acc = acc.concat(curr.split(';'));
                            return acc;
                        }, []);
                        if (value.length > 1) {
                            if (value.includes('!')) {
                                operator = 'NOT IN';
                                value.splice(value.indexOf('!'), 1);
                            }
                            else {
                                operator = 'IN';
                            }
                        }
                        else {
                            operator = 'EXACT';
                            value = value.pop();
                        }
                        filters.push({
                            id: key,
                            type: operator,
                            value,
                        });
                    }
                }
                return filters;
            }
            function gatherFacets() {
                let facets = [];
                $form.querySelectorAll('[data-filter-facet]').forEach(($facet) => {
                    let id, operator, limit;
                    id = $facet.getAttribute('data-filter-id');
                    operator = $facet.getAttribute('data-filter-facet');
                    limit = 0;
                    if (id && operator) {
                        facets.push({
                            id,
                            operator,
                            limit
                        });
                    }
                });
                return facets;
            }
            function filterAllergen($cards, $containerModal, $modal) {
                const $buttonFilter = $containerModal.querySelector('.btn-filter');
                const $buttonApply = $containerModal.querySelector('.wrap-button-modal .btn');
                const $buttonReset = $containerModal.querySelector('.wrap-card .reset');
                const $inputModal = $containerModal.querySelector('.input-modal');
                let exclusions = { '!': true };
                let id;
                $buttonApply.disabled = true;
                $cards.forEach($card => {
                    $card.addEventListener('click', () => {
                        $card.classList.toggle('active');
                        id = $card.getAttribute('data-id');
                        if ($card.classList.contains('active')) {
                            exclusions[id] = true;
                            $buttonApply.disabled = false;
                        }
                        else {
                            delete exclusions[id];
                        }
                        setStateButtonApply($containerModal, $buttonApply);
                    });
                });
                $buttonApply.addEventListener('click', () => {
                    const keys = Object.keys(exclusions);
                    const data = keys.length >= 2 ? keys : [];
                    applyFilters($inputModal, $modal, data, $buttonFilter);
                });
                $buttonReset.addEventListener('click', () => {
                    $buttonApply.disabled = true;
                    $cards.forEach($card => {
                        $card.classList.remove('active');
                    });
                    applyFilters($inputModal, $modal, [], $buttonFilter);
                    exclusions = { '!': true };
                });
            }
            function filterProductLine($cards, $containerModal, $modal) {
                const $buttonFilter = $containerModal.querySelector('.btn-filter');
                const $buttonApply = $containerModal.querySelector('.wrap-button-modal .btn');
                const $buttonReset = $containerModal.querySelector('.wrap-card .reset');
                const $inputModal = $containerModal.querySelector('.input-modal');
                $buttonApply.disabled = true;
                $cards.forEach($card => {
                    setFilterInclude($card, $containerModal, $buttonApply);
                });
                $buttonApply.addEventListener('click', () => {
                    applyFilters($inputModal, $modal, valuesInputIncludes, $buttonFilter);
                });
                $buttonReset.addEventListener('click', () => {
                    $buttonApply.disabled = true;
                    $cards.forEach($card => {
                        $card.classList.remove('active');
                    });
                    applyFilters($inputModal, $modal, [], $buttonFilter);
                    valuesInputIncludes = [];
                });
            }
            function filterCategory($cards, $containerModal, $modal) {
                const $buttonFilter = $containerModal.querySelector('.btn-filter');
                const $buttonApply = $containerModal.querySelector('.wrap-button-modal .btn');
                const $buttonReset = $containerModal.querySelector('.wrap-card .reset');
                const $inputModal = $containerModal.querySelector('.input-modal');
                $buttonApply.disabled = true;
                activeFilterCategory($cards);
                $buttonApply.addEventListener('click', () => {
                    applyFilters($inputModal, $modal, valuesInputCategory, $buttonFilter);
                });
                $buttonReset.addEventListener('click', () => {
                    $buttonApply.disabled = true;
                    resetFiltersCategory();
                    $cards.forEach($card => {
                        $card.classList.remove('active');
                    });
                    applyFilters($inputModal, $modal, [], $buttonFilter);
                });
            }
            function setStateButtonApply($containerModal, $buttonApply) {
                const $cardsActive = $containerModal.querySelectorAll('.card.active').length;
                $cardsActive > 0 ? $buttonApply.disabled = false : $buttonApply.disabled = true;
            }
            function applyFilters($inputModal, $modal, value, $buttonFilter) {
                $inputModal.value = value.join(";");
                $modal.classList.add('hidden');
                document.body.style.position = 'static';
                currentPage = 0;
                payload.paging = 0;
                if ($inputModal.value) {
                    $buttonFilter.classList.add('active');
                }
                else {
                    $buttonFilter.classList.remove('active');
                }
                executeSearch();
            }
            function activeFilterCategory($cards) {
                let $id;
                $cards.forEach($card => {
                    $card.addEventListener('click', () => {
                        removeActiveCard();
                        $card.classList.add('active');
                        $wrapper.querySelector('.container-btn').classList.add('scroll-zone');
                        $id = $card.getAttribute('data-id');
                        const containerResult = $wrapper.querySelector('.container-modal-general .result-category');
                        containerResult.classList.add('is-full');
                        containerResult.innerHTML = '';
                        findSubcategory($id);
                    });
                });
            }
            function removeActiveCard() {
                const $containerBtnCategory = $wrapper.querySelector('#modalCategory .container-btn');
                const $cards = $containerBtnCategory === null || $containerBtnCategory === void 0 ? void 0 : $containerBtnCategory.querySelectorAll('.card');
                const containerResult = $wrapper.querySelector('.container-modal-general .result-category');
                $cards === null || $cards === void 0 ? void 0 : $cards.forEach($card => {
                    if ($card.classList.contains('active') && $containerBtnCategory) {
                        $card.classList.remove('active');
                        $containerBtnCategory.classList.remove('scroll-zone');
                        containerResult.classList.remove('is-full');
                        valuesInputCategory = [];
                    }
                });
            }
            function removeActiveSubcategory() {
                const $subcategories = $wrapper.querySelectorAll('.container-modal-general .result-category > .category');
                $subcategories.forEach($subcategory => {
                    $subcategory.classList.remove('active');
                });
            }
            function removeActiveThirdCategory() {
                const $thirdCategories = $wrapper.querySelectorAll('.container-modal-general .result-category > .category > ul');
                $thirdCategories.forEach($thirdCategory => {
                    $thirdCategory.remove();
                });
            }
            function printCheckAllCategories($id) {
                let containerResult = $wrapper.querySelector('.container-modal-general .result-category');
                let checkAll = document.createElement('div');
                checkAll.classList.add('check-all');
                checkAll.innerHTML = 'Tutti';
                containerResult.appendChild(checkAll);
                setFilterAllCategories(checkAll, $id);
            }
            function printCategory(result) {
                let containerResult = $wrapper.querySelector('.container-modal-general .result-category');
                let category = document.createElement('div');
                let categoryLabel = document.createElement('span');
                category.classList.add('category');
                if (result) {
                    category.setAttribute('data-id', result.tid);
                    categoryLabel.innerHTML = result.name.charAt(0).toUpperCase() + result.name.slice(1).toLowerCase();
                    category.appendChild(categoryLabel);
                    containerResult.appendChild(category);
                    setFilterCategory(category, categoryLabel);
                }
            }
            function printThirdCategory(containerThirdCategory, subCategory, $id) {
                let containerResult = $wrapper.querySelector(`.category[data-id='${$id}']`);
                let listThirdCategory = document.createElement('li');
                if (subCategory) {
                    listThirdCategory.setAttribute('data-id', subCategory.tid);
                    listThirdCategory.innerHTML = subCategory.name;
                    containerThirdCategory.appendChild(listThirdCategory);
                    containerResult.appendChild(containerThirdCategory);
                    setFilterThirdCategory(listThirdCategory, $id);
                }
            }
            function setFilterAllCategories(checkAll, $id) {
                const $buttonApply = $wrapper.querySelector('#modalCategory .wrap-button-modal .btn');
                $buttonApply.disabled = true;
                checkAll.addEventListener('click', () => {
                    removeActiveSubcategory();
                    removeActiveThirdCategory();
                    checkAll.classList.toggle('active');
                    $buttonApply.disabled = false;
                    getCategory($id).then(results => {
                        results.forEach(result => {
                            if (checkAll.classList.contains('active')) {
                                valuesInputCategory.push(result.tid);
                            }
                            else {
                                valuesInputCategory = [];
                                $buttonApply.disabled = true;
                            }
                        });
                    });
                });
            }
            function setFilterCategory(category, categoryLabel) {
                const $checkAll = $wrapper.querySelector('.container-modal-general .result-category .check-all');
                const $buttonApply = $wrapper.querySelector('#modalCategory .wrap-button-modal .btn');
                let containerThirdCategory = document.createElement('ul');
                categoryLabel.addEventListener('click', () => {
                    removeActiveSubcategory();
                    removeActiveThirdCategory();
                    valuesInputCategory = [];
                    containerThirdCategory.innerHTML = '';
                    containerThirdCategory.remove();
                    const $id = category.getAttribute('data-id');
                    category.classList.toggle('active');
                    const $categoriesActive = $wrapper.querySelectorAll('.result-category .category.active').length;
                    getCategory($id).then(results => {
                        if (results.length > 0) {
                            results.forEach(result => {
                                if (category.classList.contains('active')) {
                                    if ($checkAll.classList.contains('active')) {
                                        $checkAll.classList.remove('active');
                                        valuesInputCategory = [];
                                    }
                                    removeFilterFacets();
                                    printThirdCategory(containerThirdCategory, result, $id);
                                    removeFilterFacets();
                                    valuesInputCategory.push(result.tid);
                                }
                            });
                        }
                        else {
                            if (category.classList.contains('active')) {
                                valuesInputCategory.push($id);
                            }
                        }
                    });
                    $categoriesActive > 0 ? $buttonApply.disabled = false : $buttonApply.disabled = true;
                });
            }
            function setFilterThirdCategory(subCategory, $id) {
                const $buttonApply = $wrapper.querySelector('#modalCategory .wrap-button-modal .btn');
                const categoryActive = $wrapper.querySelector(`.category[data-id='${$id}']`);
                subCategory.addEventListener('click', () => {
                    if (categoryActive.classList.contains('active')) {
                        categoryActive.classList.remove('active');
                        valuesInputCategory = [];
                    }
                    subCategory.classList.toggle('active');
                    const $subCategoriesActive = $wrapper.querySelectorAll('.result-category .category li.active').length;
                    const $idSubCategory = subCategory.getAttribute('data-id');
                    if (subCategory.classList.contains('active')) {
                        valuesInputCategory.push($idSubCategory);
                    }
                    else {
                        valuesInputCategory = valuesInputCategory.filter(value => value !== $idSubCategory);
                    }
                    $subCategoriesActive > 0 ? $buttonApply.disabled = false : $buttonApply.disabled = true;
                });
            }
            function getCategory($id) {
                return new Promise((resolve, reject) => {
                    productCategory($id).then(response => {
                        resolve(response);
                        cacheCategories[$id] = response;
                    }).catch(() => {
                        reject();
                    });
                });
            }
            function setFilterInclude($card, $containerModal, $buttonApply) {
                let $id;
                $card.addEventListener('click', () => {
                    $card.classList.toggle('active');
                    $id = $card.getAttribute('data-id');
                    if ($card.classList.contains('active')) {
                        valuesInputIncludes.push($id);
                    }
                    else {
                        valuesInputIncludes = valuesInputIncludes.filter(value => value !== $id);
                    }
                    setStateButtonApply($containerModal, $buttonApply);
                });
            }
            function resetFiltersCategory() {
                let $resultCategory = $wrapper.querySelector('.result-category');
                currentPage = 0;
                payload.paging = 0;
                removeActiveCard();
                valuesInputCategory = [];
                if ($resultCategory) {
                    $resultCategory.innerHTML = '';
                }
            }
            function resetAllFilters() {
                $btnResetAll.classList.add('hide');
                resetFiltersCategory();
                const $containerModals = $form.querySelectorAll('.filter-modal');
                const $inputs = $wrapper.querySelectorAll("input");
                valuesInputIncludes = [];
                $containerModals.forEach($modal => {
                    const $input = $modal.querySelector('.input-modal');
                    const $button = $modal.querySelector('.btn-filter');
                    const $buttonApply = $modal.querySelector('.wrap-button-modal .btn');
                    const $cardActive = $modal.querySelectorAll('.card');
                    $input.value = '';
                    $button.classList.remove('active');
                    $buttonApply.disabled = true;
                    $cardActive.forEach($card => {
                        $card.classList.remove('active');
                    });
                });
                $inputs.forEach($input => {
                    $input.checked = false;
                });
                const $selects = $filterBar.querySelectorAll('select');
                if ($selects.length) {
                    const selectCollection = tail.select($selects, selectsConfiguration);
                    selectCollection.options.handle("select", 'Seleziona un elemento', '#');
                }
                payload.filters = gatherFilters();
                payload.page = 0;
                search(payload).then(results => {
                    cacheFacets = results.facets;
                    print(results);
                    AdvertisingCatalog();
                    getOsbImage();
                });
            }
            function closeModal($modal) {
                $modal.classList.add('hidden');
                document.body.style.position = 'static';
            }
            function openModal($modal) {
                $modal.classList.remove('hidden');
                document.body.style.position = 'fixed';
            }
            function print(resultsWrapper, addOnTop = false) {
                clusters = {};
                if (!addOnTop) {
                    $results.innerHTML = '';
                    $resultCount.innerHTML = `<b>${resultsWrapper.count} </b>${resultsWrapper.count === 1 ? 'risultato trovato' : 'risultati trovati'}`;
                }
                else {
                    $results.querySelector('.result-paging').remove();
                    $results.querySelector('.button-wrapper').remove();
                }
                if (resultsWrapper.results.length) {
                    const clusterElement = $resultsClusterDummy.cloneNode(true);
                    const resultBox = clusterElement.querySelector('.results-box');
                    const btnUploadProduct = clusterElement.querySelector('.btn');
                    btnUploadProduct.innerHTML = 'Carica altri prodotti';
                    if (resultsWrapper.paging > resultsWrapper.results.length) {
                        btnUploadProduct.classList.add('d-none');
                    }
                    else {
                        btnUploadProduct.classList.remove('d-none');
                        viewMoreResults(btnUploadProduct);
                    }
                    let bundleResults = resultsWrapper.results[0].bundle;
                    let clusterSizes;
                    bundleResults && bundleResults === 'recipe' || bundleResults === 'suggestion' ? clusterSizes = ('3:2' || '1').split(':') : clusterSizes = ('4:2' || '1').split(':');
                    clusterElement.classList.remove('dummy');
                    resultBox.classList.add(`col-num-${clusterSizes[0]}`);
                    resultBox.classList.add(`col-num-${clusterSizes.length > 1 ? clusterSizes[1] : clusterSizes[0]}-xs`);
                    printClusterResults(resultBox, resultsWrapper);
                    let resultPagingText;
                    let resultPaging = document.createElement('div');
                    resultPaging.classList.add('result-paging');
                    payload.paging += resultsWrapper.results.length;
                    resultPagingText = `Hai visualizzato <b>${payload.paging}</b> di <b>${resultsWrapper.count}</b> prodotti`;
                    resultPaging.innerHTML = resultPagingText;
                    resultBox.parentNode.insertBefore(resultPaging, resultBox.nextSibling);
                    $results.appendChild(clusterElement);
                }
                removeFilterFacets();
                $wrapper.removeAttribute('data-spinner');
            }
            function removeVisibilityFilter() {
                const $cards = $wrapper.querySelectorAll('.container-modal-general .visibility-filter');
                const $buttons = $wrapper.querySelectorAll('.btn-set');
                $cards.forEach($card => {
                    $card.classList.remove('visibility-filter');
                });
                $buttons.forEach($button => {
                    $button.classList.add('disabled');
                });
            }
            function removeFilterFacets() {
                removeVisibilityFilter();
                $form.querySelectorAll('[data-filter-facet]').forEach(($facet) => {
                    const id = $facet.getAttribute('data-filter-id');
                    if (cacheFacets) {
                        cacheFacets[id].forEach(result => {
                            result.filter = result.filter.split('"').join('');
                            const card = $form.querySelector(`[data-id='${result.filter}']`);
                            if (card) {
                                card.classList.add('visibility-filter');
                            }
                            const button = $form.querySelector(`[id='${result.filter}']`);
                            if (button) {
                                button.classList.remove('disabled');
                            }
                        });
                    }
                });
            }
            function viewMoreResults(buttonUploadProduct) {
                payload = updatePayload(payload);
                buttonUploadProduct.addEventListener('click', () => {
                    currentPage++;
                    payload.page = currentPage;
                    search(payload).then((results) => {
                        cacheFacets = results.facets;
                        print(results, true);
                        AdvertisingCatalog();
                        getOsbImage();
                    });
                });
            }
            function printClusterResults(resultBox, resultsWrapper) {
                resultBox.innerHTML = '';
                if (clusters) {
                    resultsWrapper.results.forEach(result => {
                        const resultDiv = document.createElement('div');
                        if (result.bundle === 'recipe' || result.bundle === 'suggestion') {
                            resultDiv.classList.add('result-wrapper', 'card-item', 'white');
                        }
                        else {
                            resultDiv.classList.add('result-wrapper', 'card-item', 'border-full', 'card-white');
                        }
                        resultDiv.innerHTML = result.render;
                        resultBox.appendChild(resultDiv);
                    });
                }
                else {
                    resultBox.innerHTML = 'Nessun risultato trovato';
                }
            }
            function activeFilterGeneral() {
                const $filters = $form.querySelectorAll('input:not(.input-modal)');
                const $containerModals = $form.querySelectorAll('.filter-modal');
                $containerModals.forEach($containerModal => {
                    const $button = $containerModal.querySelector('.btn-filter');
                    const $modalVisible = $containerModal.querySelector('.container-modal-general');
                    const $modal = $containerModal.querySelector('.container-modal-general.hidden');
                    let idModal = $modal.id;
                    let targetModal = $button.getAttribute('data-target');
                    if (targetModal === idModal) {
                        $button.addEventListener('click', () => {
                            openModal($modal);
                        });
                        bindFilterModalSearch($containerModal, $modal, idModal);
                    }
                    $modal.querySelector('.icn-close').addEventListener('click', () => {
                        closeModal($modal);
                    });
                    document.body.addEventListener('click', (event) => {
                        if (event.target == $modalVisible) {
                            closeModal($modal);
                        }
                    });
                });
                $filters.forEach(inputFilter => {
                    inputFilter.addEventListener('click', () => {
                        currentPage = 0;
                        payload.paging = 0;
                        executeSearch();
                    });
                });
            }
            function attachSelectsListeners() {
                const $selects = $filterBar.querySelectorAll('select');
                if ($selects.length) {
                    const selectCollection = tail.select($selects, selectsConfiguration);
                    const selectList = Array.isArray(selectCollection)
                        ? selectCollection
                        : [selectCollection];
                    selectList.forEach(select => {
                        select.on('open', () => {
                            $filterBar.classList.add('showOverflowY');
                        });
                        select.on('close', () => {
                            $filterBar.classList.remove('showOverflowY');
                        });
                        select.on('change', () => {
                            currentPage = 0;
                            payload.paging = 0;
                            executeSearch();
                        });
                        select.reload();
                    });
                }
            }
            function initUI() {
                attachSelectsListeners();
                activeFilterGeneral();
                $form.addEventListener('submit', e => {
                    e.preventDefault();
                });
                $query.addEventListener('keypress', e => {
                    $query.parentElement.classList.toggle('is-filled', !!$query.value);
                    if (e.key === 'Enter') {
                        currentPage = 0;
                        payload.paging = 0;
                        executeSearch();
                    }
                });
                if ($btnResetAll) {
                    $btnResetAll.addEventListener('click', () => {
                        resetAllFilters();
                    });
                }
                const $btnReset = $wrapper.querySelector('a.reset');
                if ($btnReset) {
                    $btnReset.addEventListener('click', () => {
                        resetFiltersCategory();
                    });
                }
                $clear.addEventListener('click', () => {
                    $query.value = '';
                    currentPage = 0;
                    payload.paging = 0;
                    trigger($query, 'keypress');
                    history.pushState({}, '', location.href.replace(location.search, ''));
                    executeSearch();
                });
                $searchBtn.addEventListener('click', () => {
                    currentPage = 0;
                    payload.paging = 0;
                    executeSearch();
                });
            }
            function init() {
                const queryParams = new URLSearchParams(location.search);
                initUI();
                if (queryParams.get('query')) {
                    $query.value = queryParams.get('query');
                    trigger($query, 'keypress');
                }
                executeSearch();
            }
            init();
        }
    });
})(SearchController || (SearchController = {}));
